// Calculadora de Churrasco
class CalculadoraChurrasco {
    constructor() {
        // Quantidades padrão de carne por tipo de pessoa (em gramas)
        this.gramasHomem = 400;
        this.gramasMulher = 300;
        this.gramasCrianca = 200;

        this.tempo2h = 0.8;
        this.tempo4h = 1.0;
        this.tempo4hMais = 1.25;

        // Carregar textos de tradução
        this.loadTranslations();

        // Garantir que listeners globais sejam registrados apenas uma vez
        this.documentListenersBound = false;

        this.init();
    }

    loadTranslations() {
        // Tentar carregar traduções do data attribute
        const homeElement = document.querySelector('.calculadora-de-churrasco-home');
        if (homeElement && homeElement.dataset.lang) {
            try {
                this.translations = JSON.parse(homeElement.dataset.lang);
                
                // Verificar se há parâmetro de URL para forçar idioma
                const urlParams = new URLSearchParams(window.location.search);
                const forcedLang = urlParams.get('lang');
                if (forcedLang && ['pt-br', 'en', 'es'].includes(forcedLang)) {
                    // Recarregar traduções com o idioma forçado
                    // As traduções já vêm do PHP com o idioma correto, mas podemos validar aqui
                    //console.log('Idioma forçado via URL:', forcedLang);
                }
            } catch (e) {
                console.warn('Erro ao carregar traduções:', e);
                this.translations = {};
            }
        } else {
            this.translations = {};
        }
    }

    t(key, defaultValue = '') {
        // Navegar pela chave (ex: 'javascript.erro_ocasiao')
        const keys = key.split('.');
        let value = this.translations;
        
        for (const k of keys) {
            if (value && typeof value === 'object' && k in value) {
                value = value[k];
            } else {
                return defaultValue || key;
            }
        }
        
        return typeof value === 'string' ? value : (defaultValue || key);
    }

    init() {
        this.bindEvents();
    }

    bindEvents() {
        const form = document.querySelector('.calculadora-de-churrasco-home form');
        if (form) {
            // Prevenir números negativos nos campos de número
            const numberInputs = form.querySelectorAll('input[type="number"]');
            numberInputs.forEach(input => {
                input.addEventListener('keydown', (e) => {
                    // Prevenir tecla de menos (-) e sinal de menos no teclado numérico
                    if (e.key === '-' || e.key === 'e' || e.key === 'E' || e.key === '+') {
                        e.preventDefault();
                    }
                });
                
                input.addEventListener('input', (e) => {
                    // Garantir que o valor nunca seja negativo
                    if (parseFloat(e.target.value) < 0) {
                        e.target.value = 0;
                    }
                });
            });

            form.addEventListener('submit', (e) => {
                e.preventDefault();
                
                // Capturar a ocasião selecionada
                const ocasiaoSelecionada = form.querySelector('input[name="ocasiao"]:checked');
                if (!ocasiaoSelecionada) {
                    alert(this.t('javascript.erro_ocasiao', 'Por favor, selecione uma ocasião'));
                    return;
                }
                
                // Capturar a duração selecionada
                const duracaoSelecionada = form.querySelector('input[name="duracao"]:checked');
                if (!duracaoSelecionada) {
                    alert(this.t('javascript.erro_duracao', 'Por favor, selecione uma duração'));
                    return;
                }
                
                // Capturar valores do formulário
                const homens = Math.max(0, parseInt(form.querySelector('#homens').value) || 0);
                const mulheres = Math.max(0, parseInt(form.querySelector('#mulheres').value) || 0);
                const criancas = Math.max(0, parseInt(form.querySelector('#crianças').value) || 0);
                
                // Validar que pelo menos 1 pessoa foi informada
                const totalPessoas = homens + mulheres + criancas;
                if (totalPessoas === 0) {
                    alert(this.t('javascript.erro_pessoas', 'Por favor, informe pelo menos 1 pessoa (homem, mulher ou criança)'));
                    return;
                }
                
                const ocasiaoId = ocasiaoSelecionada.id; // 'ocasiao-1', 'ocasiao-2', etc.
                const ocasiaoKey = ocasiaoId.replace('ocasiao-', 'ocasiao_'); // 'ocasiao_1', 'ocasiao_2', etc.
                const ocasiaoNumero = ocasiaoId.replace('ocasiao-', ''); // '1', '2', '3'
                
                // Armazenar os dados do formulário
                this.dadosFormulario = {
                    homens,
                    mulheres,
                    criancas,
                    duracaoId: duracaoSelecionada.id, // 'duracao-1', 'duracao-2', 'duracao-3'
                    ocasiaoNumero: parseInt(ocasiaoNumero) // 1, 2, ou 3
                };
                
                this.abrirModalCortes(ocasiaoKey);
            });
        }

        if (!this.documentListenersBound) {
            // Event delegation para o botão "Calcular" dentro do formulário de cortes
            document.addEventListener('click', (e) => {
                // Verificar se o clique foi no botão "Calcular" do formulário de cortes
                // Buscar por ID primeiro, depois verificar se está dentro do formulário de cortes
                const btnCalcular = e.target.closest('#btn-calcular-cortes') || 
                                   e.target.closest('.cortes-calculadora-de-churrasco form .btn-primary');
                if (btnCalcular && btnCalcular.id === 'btn-calcular-cortes') {
                    e.preventDefault();
                    e.stopPropagation();
                    
                    // Encontrar o formulário
                    const form = btnCalcular.closest('form');
                    
                    if (form) {
                        // Capturar os cortes selecionados
                        const cortesSelecionados = this.obterCortesSelecionados(form);
                        
                        // Abrir resultado substituindo o conteúdo
                        this.abrirModalResultado(cortesSelecionados);
                    }
                }
            });

            // Também interceptar o submit do formulário de cortes
            document.addEventListener('submit', (e) => {
                const form = e.target.closest('form');
                // Verificar se é o formulário de cortes (pode estar dentro de diferentes containers)
                if (form && (form.querySelector('#btn-calcular-cortes') || form.closest('.cortes-calculadora-de-churrasco'))) {
                    e.preventDefault();
                    e.stopPropagation();
                    
                    // Capturar os cortes selecionados
                    const cortesSelecionados = this.obterCortesSelecionados(form);
                    
                    // Abrir resultado substituindo o conteúdo
                    this.abrirModalResultado(cortesSelecionados);
                }
            });

            // Event delegation para o botão "Recalcular" no resultado
            document.addEventListener('click', (e) => {
                const btnRecalcular = e.target.closest('.result-ocasiao-1 .btn-primary');
                const recalcularText = this.t('resultado.recalcular', 'Recalcular');
                if (btnRecalcular && btnRecalcular.textContent.trim().includes(recalcularText)) {
                    e.preventDefault();
                    e.stopPropagation();
                    
                    // Voltar para a tela inicial e limpar formulário
                    this.voltarParaHome();
                    this.limparFormulario();
                }
            });

            // Event delegation para o botão "Exportar PDF" no modal de resultado
            document.addEventListener('click', (e) => {
                const btnExportarPDF = e.target.closest('.btn-exportar-pdf');
                if (btnExportarPDF) {
                    e.preventDefault();
                    e.stopPropagation();
                    
                    // Encontrar o modal de resultado atual
                    const modalResultado = btnExportarPDF.closest('.result-ocasiao-1');
                    if (modalResultado) {
                        this.exportarParaPDF(modalResultado);
                    }
                }
            });

            // Event delegation para o botão "Compartilhar" no modal de resultado
            document.addEventListener('click', (e) => {
                const btnCompartilhar = e.target.closest('.btn-compartilhar');
                if (btnCompartilhar) {
                    e.preventDefault();
                    e.stopPropagation();
                    
                    // Encontrar o modal de resultado atual
                    const modalResultado = btnCompartilhar.closest('.result-ocasiao-1');
                    if (modalResultado) {
                        this.prepararDadosCompartilhamento(modalResultado);
                    }
                }
            });

            // Event delegation para o botão "Conheça a marca ..." no modal de resultado
            document.addEventListener('click', (e) => {
                const btnSaibamais = e.target.closest('.btn-saibamais-resultado');
                if (btnSaibamais) {
                    // Identificar qual linha foi escolhida baseado na classe do botão
                    let linha = '';
                    if (btnSaibamais.classList.contains('btn-saibamais-1')) {
                        linha = 'PUL';
                    } else if (btnSaibamais.classList.contains('btn-saibamais-2')) {
                        linha = 'Estância 92';
                    } else if (btnSaibamais.classList.contains('btn-saibamais-3')) {
                        linha = 'Cabaña Las Lilas';
                    }
                    
                    // Disparar evento GA4
                    this.dispararEventoGA4ConhecaMarca(linha);
                }
            });

            // Prevenir scroll da página ao clicar nos labels dos cortes
            document.addEventListener('click', (e) => {
                const label = e.target.closest('.cortes-calculadora-de-churrasco label');
                if (label) {
                    const checkbox = label.querySelector('input[type="checkbox"]');
                    if (checkbox) {
                        // Salvar a posição atual do scroll da página
                        const scrollY = window.scrollY;
                        const scrollX = window.scrollX;
                        
                        // Prevenir o comportamento padrão do label (que pode causar scroll)
                        e.preventDefault();
                        e.stopPropagation();
                        
                        // Alternar o checkbox manualmente
                        checkbox.checked = !checkbox.checked;
                        
                        // Disparar eventos para garantir que outros listeners sejam notificados
                        checkbox.dispatchEvent(new Event('change', { bubbles: true }));
                        checkbox.dispatchEvent(new Event('input', { bubbles: true }));
                        
                        // Restaurar a posição do scroll após um pequeno delay
                        setTimeout(() => {
                            window.scrollTo({
                                top: scrollY,
                                left: scrollX,
                                behavior: 'instant'
                            });
                        }, 0);
                    }
                }
            }, true); // Usar capture phase para interceptar antes de outros handlers

            this.documentListenersBound = true;
        }
    }

    abrirModalCortes(ocasiaoKey = 'ocasiao_1') {
        // Buscar conteúdo escondido do cortes.php
        const conteudoEscondido = document.querySelector('.modal-cortes-content');
        if (!conteudoEscondido) {
            console.error('Conteúdo do modal não encontrado');
            return;
        }

        // Buscar o container principal da calculadora (pode ter diferentes classes)
        const homeContainer = document.querySelector('.calculadora-de-churrasco-home, .calculadora-de-churrasco-cortes, .calculadora-de-churrasco-resultado');
        if (!homeContainer) {
            console.error('Container da calculadora não encontrado');
            return;
        }

        // Salvar o conteúdo original para poder voltar
        if (!homeContainer.dataset.originalContent) {
            homeContainer.dataset.originalContent = homeContainer.innerHTML;
        }

        // Clonar o conteúdo escondido
        const conteudoClone = conteudoEscondido.cloneNode(true);
        conteudoClone.style.display = 'block';
        
        // Filtrar e mostrar apenas os cortes da ocasião selecionada
        const cortesItems = conteudoClone.querySelectorAll('.corte-item');
        cortesItems.forEach(item => {
            const itemOcasiao = item.getAttribute('data-ocasiao');
            if (itemOcasiao === ocasiaoKey) {
                item.style.display = 'block';
            } else {
                item.style.display = 'none';
            }
        });

        // Preservar elementos importantes antes de substituir o conteúdo
        const modalShare = homeContainer.querySelector('.share-modal-container');
        const modalShareHTML = modalShare ? modalShare.outerHTML : '';
        const modalCortesContent = homeContainer.querySelector('.modal-cortes-content');
        const modalCortesHTML = modalCortesContent ? modalCortesContent.outerHTML : '';
        const modalResultadoContent = homeContainer.querySelector('.modal-resultado-content');
        const modalResultadoHTML = modalResultadoContent ? modalResultadoContent.outerHTML : '';

        // Remover classes CSS do container original para que a tela de cortes tenha sua própria aparência
        homeContainer.className = 'calculadora-de-churrasco-cortes mb-8';
        homeContainer.removeAttribute('data-lang');
        
        // Remover altura fixa e overflow para permitir expansão do conteúdo
        homeContainer.style.height = 'auto';
        homeContainer.style.overflow = 'visible';

        // Substituir o conteúdo do container principal
        homeContainer.innerHTML = conteudoClone.innerHTML;

        // Restaurar elementos preservados
        if (modalCortesHTML) {
            homeContainer.insertAdjacentHTML('beforeend', modalCortesHTML);
        }
        if (modalResultadoHTML) {
            homeContainer.insertAdjacentHTML('beforeend', modalResultadoHTML);
        }
        if (modalShareHTML) {
            homeContainer.insertAdjacentHTML('beforeend', modalShareHTML);
        }
    }

    calcularPesoTotal() {
        if (!this.dadosFormulario) {
            return 0;
        }

        const { homens, mulheres, criancas, duracaoId } = this.dadosFormulario;

        // Calcular peso base em gramas
        const pesoBaseGramas = (homens * this.gramasHomem) + 
                               (mulheres * this.gramasMulher) + 
                               (criancas * this.gramasCrianca);

        // Aplicar multiplicador de duração
        let multiplicador = 1.0;
        if (duracaoId === 'duracao-1') {
            multiplicador = this.tempo2h;
        } else if (duracaoId === 'duracao-2') {
            multiplicador = this.tempo4h;
        } else if (duracaoId === 'duracao-3') {
            multiplicador = this.tempo4hMais;
        }

        const pesoTotalGramas = pesoBaseGramas * multiplicador;
        
        // Converter para kg e arredondar para 2 casas decimais
        const pesoTotalKg = Math.round((pesoTotalGramas / 1000) * 100) / 100;
        
        return pesoTotalKg;
    }

    obterCortesSelecionados(form) {
        const checkboxes = form.querySelectorAll('input[type="checkbox"]:checked');
        const cortesSelecionados = [];
        checkboxes.forEach(checkbox => {
            cortesSelecionados.push(checkbox.value);
        });
        return cortesSelecionados;
    }

    abrirModalResultado(cortesSelecionados = []) {
        // Buscar conteúdo escondido do result_ocasiao_1.php
        const conteudoEscondido = document.querySelector('.modal-resultado-content');
        if (!conteudoEscondido) {
            console.error('Conteúdo do modal de resultado não encontrado');
            return;
        }

        // Buscar o container principal da calculadora (pode ter diferentes classes)
        const homeContainer = document.querySelector('.calculadora-de-churrasco-home, .calculadora-de-churrasco-cortes, .calculadora-de-churrasco-resultado');
        if (!homeContainer) {
            console.error('Container da calculadora não encontrado');
            return;
        }

        // Salvar o conteúdo original para poder voltar
        if (!homeContainer.dataset.originalContent) {
            homeContainer.dataset.originalContent = homeContainer.innerHTML;
        }

        // Calcular peso total
        const pesoTotal = this.calcularPesoTotal();

        // Obter número da ocasião selecionada
        const ocasiaoNumero = this.dadosFormulario?.ocasiaoNumero || 1;

        // Clonar o conteúdo escondido
        const conteudoClone = conteudoEscondido.cloneNode(true);
        conteudoClone.style.display = 'block';
        
        // Mostrar apenas a imagem e título correspondentes à ocasião selecionada
        // Esconder todas as imagens e títulos primeiro
        for (let i = 1; i <= 3; i++) {
            const descricao = conteudoClone.querySelector(`.descricao-calculadora-de-churrasco-result-${i}`);
            const img = conteudoClone.querySelector(`.bg-calculadora-de-churrasco-result-${i}`);
            const titulo = conteudoClone.querySelector(`.titulo-calculadora-de-churrasco-result-${i}`);
            const btnSaibamais = conteudoClone.querySelector(`.btn-saibamais-${i}`);
            
            if (descricao) {
                descricao.style.display = i === ocasiaoNumero ? 'block' : 'none';
            }

            if (img) {
                img.style.display = i === ocasiaoNumero ? 'block' : 'none';
            }
            
            if (titulo) {
                titulo.style.display = i === ocasiaoNumero ? 'block' : 'none';
            }

            if (btnSaibamais) {
                btnSaibamais.style.display = i === ocasiaoNumero ? 'inline-flex' : 'none';
            }
        }
        
        // Atualizar o peso total no texto
        const pesoTotalValor = conteudoClone.querySelector('.peso-total-valor');
        if (pesoTotalValor) {
            pesoTotalValor.textContent = pesoTotal;
        }
        
        // Calcular peso por corte (distribuir o total igualmente entre os cortes)
        const pesoPorCorte = cortesSelecionados.length > 0 
            ? Math.round((pesoTotal / cortesSelecionados.length) * 100) / 100 
            : 0;
        
        // Inserir os cortes selecionados
        const cortesList = conteudoClone.querySelector('.cortes-selecionados-list');
        if (cortesList && cortesSelecionados.length > 0) {
            cortesList.innerHTML = '';
            cortesSelecionados.forEach(corteKey => {
                // Buscar o nome traduzido do corte usando a chave
                const corteNome = this.t(`cortes.nomes.${corteKey}`, corteKey);
                const corteItem = document.createElement('div');
                corteItem.className = 'col-span-1 flex flex-col';
                corteItem.innerHTML = `
                    <span class="text-12 font-bold text-dourado leading-tight mb-1">${corteNome}</span>
                    <span class="text-20 font-semibold text-white">${pesoPorCorte}kg</span>
                `;
                cortesList.appendChild(corteItem);
            });
        } else if (cortesList && cortesSelecionados.length === 0) {
            cortesList.innerHTML = `<p>${this.t('resultado.nenhum_corte', 'Nenhum corte selecionado.')}</p>`;
        }

        // Preservar elementos importantes antes de substituir o conteúdo
        const modalShare = homeContainer.querySelector('.share-modal-container');
        const modalShareHTML = modalShare ? modalShare.outerHTML : '';
        const modalCortesContent = homeContainer.querySelector('.modal-cortes-content');
        const modalCortesHTML = modalCortesContent ? modalCortesContent.outerHTML : '';
        const modalResultadoContent = homeContainer.querySelector('.modal-resultado-content');
        const modalResultadoHTML = modalResultadoContent ? modalResultadoContent.outerHTML : '';

        // Remover classes CSS do container original para que a tela de resultado tenha sua própria aparência
        homeContainer.className = 'calculadora-de-churrasco-resultado mb-8';
        homeContainer.removeAttribute('data-lang');
        
        // Remover altura fixa e overflow para permitir expansão do conteúdo
        homeContainer.style.height = 'auto';
        homeContainer.style.overflow = 'visible';

        // Substituir o conteúdo do container principal
        homeContainer.innerHTML = conteudoClone.innerHTML;

        // Restaurar elementos preservados
        if (modalCortesHTML) {
            homeContainer.insertAdjacentHTML('beforeend', modalCortesHTML);
        }
        if (modalResultadoHTML) {
            homeContainer.insertAdjacentHTML('beforeend', modalResultadoHTML);
        }
        if (modalShareHTML) {
            homeContainer.insertAdjacentHTML('beforeend', modalShareHTML);
        }

        // Disparar evento GA4 com os dados coletados
        this.dispararEventoGA4Resultado(cortesSelecionados);
    }

    dispararEventoGA4Resultado(cortesSelecionados = []) {
        console.log('dispararEventoGA4Resultado');
        console.log(this.dadosFormulario);
        if (!this.dadosFormulario) {
            return;
        }

        const { homens, mulheres, criancas, duracaoId, ocasiaoNumero } = this.dadosFormulario;
        const totalPessoas = homens + mulheres + criancas;
        const pesoTotal = this.calcularPesoTotal();

        // Obter nome da ocasião traduzido
        let ocasiaoNome = '';
        let linha = '';
        if (ocasiaoNumero === 1) {
            ocasiaoNome = this.t('home.ocasiao_1', 'Churrasco em família');
            linha = 'PUL';
        } else if (ocasiaoNumero === 2) {
            ocasiaoNome = this.t('home.ocasiao_2', 'Churrasco com amigos');
            linha = 'Estância 92';
        } else if (ocasiaoNumero === 3) {
            ocasiaoNome = this.t('home.ocasiao_3', 'Churrasco especial');
            linha = 'Cabaña Las Lilas';
        }

        // Obter nome da duração traduzido
        let duracaoNome = '';
        if (duracaoId === 'duracao-1') {
            duracaoNome = this.t('home.duracao_1', 'Até 2 horas');
        } else if (duracaoId === 'duracao-2') {
            duracaoNome = this.t('home.duracao_2', '2 a 4 horas');
        } else if (duracaoId === 'duracao-3') {
            duracaoNome = this.t('home.duracao_3', 'Mais de 4 horas');
        }

        // Obter nomes dos cortes selecionados traduzidos
        const cortesNomes = cortesSelecionados.map(corteKey => {
            return this.t(`cortes.nomes.${corteKey}`, corteKey);
        });

        // Preparar parâmetros do evento GA4
        const eventParameters = {
            linha: linha,
            homens: homens,
            mulheres: mulheres,
            criancas: criancas,
            total_pessoas: totalPessoas,
            ocasiao: ocasiaoNome,
            duracao: duracaoNome,
            peso_total_kg: pesoTotal,
            quantidade_cortes: cortesSelecionados.length,
            cortes_selecionados: cortesNomes.join(', '),
            cortes_keys: cortesSelecionados.join(', ')
        };

        // Verificar se a função GA4Track está disponível (do ga4-event-tracker.js)
        if (typeof GA4Track === 'function') {
            GA4Track({
                event_type: 'event',
                event_name: 'calculadora_churrasco_resultado',
                event_parameters: eventParameters
            });
        }
        else if (typeof window.dataLayer !== 'undefined') {

            window.dataLayer.push({
                event: 'calculadora_churrasco_resultado',
                ...eventParameters
            });

        }  
        else if (typeof gtag === 'function') {
            // Fallback: usar gtag diretamente se GA4Track não estiver disponível
            gtag('event', 'calculadora_churrasco_resultado', eventParameters);
        }
        else{
            console.warn('Nenhuma função de rastreamento GA4 disponível para disparar evento de resultado');
        }
    }

    dispararEventoGA4ConhecaMarca(linha = '') {
        if (!linha) {
            return;
        }

        // Preparar parâmetros do evento GA4 - apenas linha escolhida
        const eventParameters = {
            linha: linha
        };

        // Verificar se a função GA4Track está disponível (do ga4-event-tracker.js)
        if (typeof GA4Track === 'function') {
            GA4Track({
                event_type: 'event',
                event_name: 'calculadora_churrasco_conheca_marca',
                event_parameters: eventParameters
            });
            
        } else if (typeof window.dataLayer !== 'undefined') {
            window.dataLayer.push({
                event: 'calculadora_churrasco_conheca_marca',
                ...eventParameters
            });
        } else if (typeof gtag === 'function') {
            // Fallback: usar gtag diretamente se GA4Track não estiver disponível
            gtag('event', 'calculadora_churrasco_conheca_marca', eventParameters);
        }
    }

    dispararEventoGA4ExportarPDF() {
        // Preparar parâmetros do evento GA4
        const eventParameters = {
            exportar: 'Exportar PDF'
        };

        // Verificar se a função GA4Track está disponível (do ga4-event-tracker.js)
        if (typeof GA4Track === 'function') {
            GA4Track({
                event_type: 'event',
                event_name: 'calculadora_churrasco_exportar_pdf',
                event_parameters: eventParameters
            });
            
        } else if (typeof window.dataLayer !== 'undefined') {
            window.dataLayer.push({
                event: 'calculadora_churrasco_exportar_pdf',
                ...eventParameters
            });
        } else if (typeof gtag === 'function') {
            // Fallback: usar gtag diretamente se GA4Track não estiver disponível
            gtag('event', 'calculadora_churrasco_exportar_pdf', eventParameters);
        }
    }

    dispararEventoGA4Compartilhar() {
        // Preparar parâmetros do evento GA4
        console.log('dispararEventoGA4Compartilhar');
        const eventParameters = {
            compartilhar: 'Compartilhar'
        };

        // Verificar se a função GA4Track está disponível (do ga4-event-tracker.js)
        if (typeof window.GA4Track === 'function') {
            console.log('GA4Track disponível, disparando evento de compartilhamento');
            window.GA4Track({
                event_type: 'event',
                event_name: 'calculadora_churrasco_compartilhar',
                event_parameters: eventParameters
            });
        }
        
         else if (typeof window.dataLayer !== 'undefined') {
            window.dataLayer.push({
                event: 'calculadora_churrasco_compartilhar',
                ...eventParameters
            });
        }
        else if (typeof window.gtag === 'function') {
            console.log('gtag disponível, disparando evento de compartilhamento');
            // Fallback: usar gtag diretamente se GA4Track não estiver disponível
            window.gtag('event', 'calculadora_churrasco_compartilhar', eventParameters);
        }
        else{
            console.warn('Nenhuma função de rastreamento GA4 disponível para disparar evento de compartilhamento');
        }
    }

    limparFormulario() {
        const form = document.querySelector('.calculadora-de-churrasco-home form');
        if (form) {
            // Limpar campos numéricos
            form.querySelector('#homens').value = '';
            form.querySelector('#mulheres').value = '';
            form.querySelector('#crianças').value = '';
            
            // Desmarcar radio buttons
            const radioButtons = form.querySelectorAll('input[type="radio"]');
            radioButtons.forEach(radio => {
                radio.checked = false;
            });
            
            // Limpar dados armazenados
            this.dadosFormulario = null;
        }
    }

    async exportarParaPDF(elementoResultado) {
        // Verificar se jsPDF está disponível, caso contrário carregar
        if (typeof window.jspdf === 'undefined' && typeof window.jsPDF === 'undefined') {
            try {
                await this.carregarBibliotecaPDF();
            } catch (error) {
                console.error('Erro ao carregar biblioteca PDF:', error);
                alert(this.t('javascript.erro_pdf', 'Erro ao carregar a biblioteca de PDF. Por favor, tente novamente.'));
                return;
            }
        }

        // Mostrar indicador de carregamento
        const btnExportar = elementoResultado.querySelector('.btn-exportar-pdf');
        const textoOriginal = btnExportar ? btnExportar.textContent : '';
        if (btnExportar) {
            btnExportar.disabled = true;
            btnExportar.textContent = this.t('javascript.gerando_pdf', 'Gerando PDF...');
        }

        try {
            // Extrair dados do elemento original
            let titulo = '';
            const titulos = elementoResultado.querySelectorAll('.titulo-calculadora-de-churrasco-result');
            titulos.forEach(t => {
                if (t.style.display !== 'none' && t.textContent.trim()) {
                    titulo = t.textContent.trim();
                }
            });

            let descricao = '';
            const descricoes = elementoResultado.querySelectorAll('.descricao-calculadora-de-churrasco-result');
            descricoes.forEach(d => {
                if (d.style.display !== 'none' && d.textContent.trim()) {
                    descricao = d.textContent.trim();
                }
            });

            const pesoTotalEl = elementoResultado.querySelector('.peso-total-valor');
            const pesoTotal = pesoTotalEl ? pesoTotalEl.textContent.trim() : '0';
            
            // Extrair dados de pessoas (homens, mulheres, crianças)
            const dadosFormulario = this.dadosFormulario || {};
            const homens = dadosFormulario.homens || 0;
            const mulheres = dadosFormulario.mulheres || 0;
            const criancas = dadosFormulario.criancas || 0;
            const totalPessoas = homens + mulheres + criancas;
            
            // Extrair cortes selecionados
            const cortesItems = elementoResultado.querySelectorAll('.cortes-selecionados-list .col-span-1');
            const cortes = [];
            cortesItems.forEach(item => {
                const spans = item.querySelectorAll('span');
                let nome = '';
                let peso = '';
                
                spans.forEach(span => {
                    // O nome do corte tem a classe text-dourado
                    if (span.classList.contains('text-dourado')) {
                        nome = span.textContent.trim();
                    } else if (span.classList.contains('text-white')) {
                        peso = span.textContent.trim();
                    }
                });
                
                if (nome && peso) {
                    cortes.push({ nome, peso });
                }
            });

            // Verificar se temos dados para gerar o PDF
            //console.log('Dados extraídos:', { titulo, descricao, pesoTotal, cortes });
            
            if (!titulo && !descricao && pesoTotal === '0') {
                alert(this.t('javascript.erro_extrair_dados', 'Não foi possível extrair os dados do resultado. Por favor, tente novamente.'));
                if (btnExportar) {
                    btnExportar.disabled = false;
                    btnExportar.textContent = textoOriginal;
                }
                return;
            }

            // Usar jsPDF diretamente para criar o PDF
            let jsPDFClass;
            if (window.jspdf && window.jspdf.jsPDF) {
                jsPDFClass = window.jspdf.jsPDF;
            } else if (window.jsPDF) {
                jsPDFClass = window.jsPDF;
            } else {
                throw new Error('jsPDF não está disponível');
            }

            const doc = new jsPDFClass({
                orientation: 'portrait',
                unit: 'mm',
                format: 'a4'
            });

            // Configurações de fonte e cores
            const pageWidth = doc.internal.pageSize.getWidth();
            const pageHeight = doc.internal.pageSize.getHeight();
            const margin = 20;
            let yPos = margin;

            // Função auxiliar para converter imagem em base64
            const imageToBase64 = (url) => {
                return new Promise((resolve, reject) => {
                    const img = new Image();
                    img.crossOrigin = 'anonymous';
                    img.onload = () => {
                        const canvas = document.createElement('canvas');
                        canvas.width = img.width;
                        canvas.height = img.height;
                        const ctx = canvas.getContext('2d');
                        ctx.drawImage(img, 0, 0);
                        try {
                            const base64 = canvas.toDataURL('image/png');
                            resolve({ base64, width: img.width, height: img.height });
                        } catch (error) {
                            reject(error);
                        }
                    };
                    img.onerror = reject;
                    img.src = url;
                });
            };

            // Obter a URL do logo minerva-foods-footer.png
            let logoUrl = null;
            
            // Construir a URL do logo a partir de uma imagem existente
            const imgExemplo = elementoResultado.querySelector('img.bg-calculadora-de-churrasco-result');
            if (imgExemplo) {
                const src = imgExemplo.src;
                const baseUrl = src.substring(0, src.indexOf('/includes/images/'));
                logoUrl = `${baseUrl}/includes/images/minerva-foods-footer.png`;
            } else {
                // Tentar buscar qualquer imagem para obter a base URL
                const qualquerImagem = document.querySelector('img[src*="/includes/images/"]');
                if (qualquerImagem) {
                    const src = qualquerImagem.src;
                    const baseUrl = src.substring(0, src.indexOf('/includes/images/'));
                    logoUrl = `${baseUrl}/includes/images/minerva-foods-footer.png`;
                }
            }

            // Margem superior acima do logo
            const topMargin = 15;
            
            // Bloco branco para o logo (acima do bloco preto)
            const logoBlockHeight = 25;
            if (logoUrl) {
                try {
                    const logoData = await imageToBase64(logoUrl);
                    // Calcular proporção do logo
                    const logoMaxWidth = 50; // largura máxima em mm
                    const logoMaxHeight = 15; // altura máxima em mm
                    const logoAspectRatio = logoData.width / logoData.height;
                    
                    let logoWidth = logoMaxWidth;
                    let logoHeight = logoWidth / logoAspectRatio;
                    
                    // Se a altura exceder o máximo, ajustar pela altura
                    if (logoHeight > logoMaxHeight) {
                        logoHeight = logoMaxHeight;
                        logoWidth = logoHeight * logoAspectRatio;
                    }
                    
                    // Bloco branco (com margem superior)
                    doc.setFillColor(255, 255, 255);
                    doc.rect(0, topMargin, pageWidth, logoBlockHeight, 'F');
                    
                    // Adicionar logo alinhado à esquerda
                    const logoX = margin;
                    const logoY = topMargin + (logoBlockHeight - logoHeight) / 2;
                    
                    doc.addImage(logoData.base64, 'PNG', logoX, logoY, logoWidth, logoHeight);
                } catch (error) {
                    console.warn('Erro ao carregar logo:', error);
                    // Se der erro, ainda criar o bloco branco
                    doc.setFillColor(255, 255, 255);
                    doc.rect(0, topMargin, pageWidth, logoBlockHeight, 'F');
                }
            } else {
                // Criar bloco branco mesmo sem logo
                doc.setFillColor(255, 255, 255);
                doc.rect(0, topMargin, pageWidth, logoBlockHeight, 'F');
            }

            // Cabeçalho (fundo branco ou cinza claro) - melhor para impressão
            const headerHeight = 30;
            // Fundo cinza claro (#f5f5f5 = RGB 245, 245, 245)
            doc.setFillColor(245, 245, 245);
            doc.rect(0, topMargin + logoBlockHeight, pageWidth, headerHeight, 'F');
            
            // Linha divisória na parte inferior do cabeçalho para destaque
            doc.setDrawColor(26, 58, 82); // Azul escuro do tema
            doc.setLineWidth(1);
            doc.line(0, topMargin + logoBlockHeight + headerHeight, pageWidth, topMargin + logoBlockHeight + headerHeight);
            
            // Texto do cabeçalho em azul escuro (bom contraste e impressão)
            doc.setTextColor(26, 58, 82); // Azul escuro do tema
            doc.setFontSize(18);
            doc.setFont('helvetica', 'bold');
            const textY = topMargin + logoBlockHeight + (headerHeight / 2) + 3; // Centralizado verticalmente no bloco
            doc.text(descricao || this.t('home.title', 'Calculadora de Churrasco'), margin, textY);

            yPos = topMargin + logoBlockHeight + headerHeight + 10;

            // Margem acima do título
            yPos += 15;

            // Título
            doc.setTextColor(26, 58, 82); // #1a3a52
            doc.setFontSize(22);
            doc.setFont('helvetica', 'bold');
            doc.text(titulo || this.t('javascript.resultado_calculadora', 'Resultado da Calculadora'), margin, yPos);
            yPos += 15;

            // Peso total
            doc.setTextColor(0, 0, 0);
            doc.setFontSize(14);
            doc.setFont('helvetica', 'normal');
            const pesoTexto = `${this.t('resultado.peso_texto', 'Para este evento, você precisará de')} ${pesoTotal} ${this.t('resultado.peso_kg', 'kg de carne.')}`;
            doc.text(pesoTexto, margin, yPos);
            yPos += 15;

            // Informações de pessoas
            if (totalPessoas > 0) {
                doc.setTextColor(26, 58, 82);
                doc.setFontSize(16);
                doc.setFont('helvetica', 'bold');
                doc.text(this.t('javascript.informacoes_evento', 'Informações do Evento'), margin, yPos);
                yPos += 10;

                // Linha divisória
                doc.setDrawColor(26, 58, 82);
                doc.setLineWidth(0.5);
                doc.line(margin, yPos, pageWidth - margin, yPos);
                yPos += 8;

                // Fundo cinza claro para a seção
                doc.setFillColor(245, 245, 245);
                doc.roundedRect(margin, yPos - 5, pageWidth - (margin * 2), 20, 1, 1, 'F');
                
                // Borda esquerda dourada
                doc.setFillColor(199, 178, 117);
                doc.rect(margin, yPos - 5, 2, 20, 'F');

                // Texto das pessoas
                doc.setTextColor(0, 0, 0);
                doc.setFontSize(12);
                doc.setFont('helvetica', 'normal');
                
                const pessoasTexto = [];
                if (homens > 0) {
                    pessoasTexto.push(`${homens} ${homens === 1 ? this.t('javascript.homem', 'homem') : this.t('javascript.homens', 'homens')}`);
                }
                if (mulheres > 0) {
                    pessoasTexto.push(`${mulheres} ${mulheres === 1 ? this.t('javascript.mulher', 'mulher') : this.t('javascript.mulheres', 'mulheres')}`);
                }
                if (criancas > 0) {
                    pessoasTexto.push(`${criancas} ${criancas === 1 ? this.t('javascript.crianca', 'criança') : this.t('javascript.criancas', 'crianças')}`);
                }

                const pessoasLinha = pessoasTexto.length > 0 
                    ? `${this.t('javascript.total', 'Total de')} ${totalPessoas} ${totalPessoas === 1 ? this.t('javascript.pessoa', 'pessoa') : this.t('javascript.pessoas', 'pessoas')}: ${pessoasTexto.join(', ')}`
                    : `${this.t('javascript.total', 'Total de')} ${totalPessoas} ${totalPessoas === 1 ? this.t('javascript.pessoa', 'pessoa') : this.t('javascript.pessoas', 'pessoas')}`;

                // Quebrar texto se necessário
                const maxWidth = pageWidth - (margin * 2) - 10;
                const linhas = doc.splitTextToSize(pessoasLinha, maxWidth);
                linhas.forEach((linha, index) => {
                    doc.text(linha, margin + 5, yPos + (index * 5));
                });

                yPos += linhas.length * 5 + 5;
            }

            // Margem entre os blocos
            yPos += 20;

            // Cortes selecionados
            if (cortes.length > 0) {
                doc.setTextColor(26, 58, 82);
                doc.setFontSize(16);
                doc.setFont('helvetica', 'bold');
                doc.text(this.t('javascript.cortes_selecionados', 'Cortes Selecionados'), margin, yPos);
                yPos += 10;

                // Linha divisória
                doc.setDrawColor(26, 58, 82);
                doc.setLineWidth(0.5);
                doc.line(margin, yPos, pageWidth - margin, yPos);
                yPos += 8;

                cortes.forEach(corte => {
                    // Verificar se precisa de nova página
                    if (yPos > pageHeight - 30) {
                        doc.addPage();
                        yPos = margin;
                    }

                    // Fundo cinza claro
                    doc.setFillColor(245, 245, 245);
                    doc.roundedRect(margin, yPos - 5, pageWidth - (margin * 2), 8, 1, 1, 'F');
                    
                    // Borda esquerda dourada
                    doc.setFillColor(199, 178, 117);
                    doc.rect(margin, yPos - 5, 2, 8, 'F');

                    // Nome do corte
                    doc.setTextColor(26, 58, 82);
                    doc.setFontSize(11);
                    doc.setFont('helvetica', 'bold');
                    doc.text(corte.nome, margin + 5, yPos);

                    // Peso do corte
                    doc.setTextColor(0, 0, 0);
                    doc.setFontSize(12);
                    doc.setFont('helvetica', 'bold');
                    const pesoX = pageWidth - margin - doc.getTextWidth(corte.peso);
                    doc.text(corte.peso, pesoX, yPos);

                    yPos += 12;
                });
            }

            // Rodapé
            yPos = pageHeight - 20;
            doc.setTextColor(102, 102, 102);
            doc.setFontSize(10);
            doc.setFont('helvetica', 'normal');
            const dataHora = `Gerado em ${new Date().toLocaleDateString('pt-BR')} às ${new Date().toLocaleTimeString('pt-BR')}`;
            const textoWidth = doc.getTextWidth(dataHora);
            doc.text(dataHora, (pageWidth - textoWidth) / 2, yPos);

            // Salvar o PDF
            doc.save(`calculadora-churrasco-${new Date().getTime()}.pdf`);

            // Disparar evento GA4
            this.dispararEventoGA4ExportarPDF();

            // Restaurar botão
            if (btnExportar) {
                btnExportar.disabled = false;
                btnExportar.textContent = textoOriginal;
            }
        } catch (error) {
            console.error('Erro ao gerar PDF:', error);
            alert('Erro ao gerar o PDF. Por favor, tente novamente.');
            
            // Restaurar botão em caso de erro
            if (btnExportar) {
                btnExportar.disabled = false;
                btnExportar.textContent = textoOriginal;
            }
        }
    }

    carregarBibliotecaPDF() {
        return new Promise((resolve, reject) => {
            // Verificar se já está carregado
            if (typeof window.jspdf !== 'undefined' || typeof window.jsPDF !== 'undefined') {
                resolve();
                return;
            }

            // Carregar apenas jsPDF (não precisamos mais do html2pdf)
            const script = document.createElement('script');
            script.src = 'https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js';
            script.onload = () => {
                // Aguardar um pouco para garantir que o jsPDF esteja disponível
                setTimeout(() => {
                    if (typeof window.jspdf !== 'undefined' || typeof window.jsPDF !== 'undefined') {
                        resolve();
                    } else {
                        reject(new Error('jsPDF não está disponível após carregamento'));
                    }
                }, 100);
            };
            script.onerror = () => reject(new Error('Erro ao carregar jsPDF'));
            document.head.appendChild(script);
        });
    }

    prepararDadosCompartilhamento(elementoResultado) {
        // Disparar evento GA4
        this.dispararEventoGA4Compartilhar();

        // Extrair título
        let titulo = 'Calculadora de Churrasco';
        const titulos = elementoResultado.querySelectorAll('.titulo-calculadora-de-churrasco-result');
        titulos.forEach(t => {
            if (t.style.display !== 'none' && t.textContent.trim()) {
                titulo = t.textContent.trim();
            }
        });

        // Extrair descrição (ocasião)
        let descricao = '';
        const descricoes = elementoResultado.querySelectorAll('.descricao-calculadora-de-churrasco-result');
        descricoes.forEach(d => {
            if (d.style.display !== 'none' && d.textContent.trim()) {
                descricao = d.textContent.trim();
                // Remover dois pontos no final se houver
                descricao = descricao.replace(/:$/, '');
            }
        });

        // Extrair peso total
        const pesoTotalEl = elementoResultado.querySelector('.peso-total-valor');
        const pesoTotal = pesoTotalEl ? pesoTotalEl.textContent.trim() : '0';

        // Extrair dados de pessoas (homens, mulheres, crianças) para o texto completo
        const dadosFormulario = this.dadosFormulario || {};
        const homens = dadosFormulario.homens || 0;
        const mulheres = dadosFormulario.mulheres || 0;
        const criancas = dadosFormulario.criancas || 0;
        const totalPessoas = homens + mulheres + criancas;

        // Extrair cortes selecionados
        const cortesItems = elementoResultado.querySelectorAll('.cortes-selecionados-list .col-span-1');
        const cortes = [];
        cortesItems.forEach(item => {
            const spans = item.querySelectorAll('span');
            let nome = '';
            let peso = '';
            
            spans.forEach(span => {
                // O nome do corte tem a classe text-dourado
                if (span.classList.contains('text-dourado')) {
                    nome = span.textContent.trim();
                } else if (span.classList.contains('text-white')) {
                    peso = span.textContent.trim();
                    // Remover "kg" se já estiver presente para evitar duplicação
                    peso = peso.replace(/kg$/i, '').trim();
                }
            });
            
            if (nome && peso) {
                cortes.push({ nome, peso });
            }
        });

        // Criar texto formatado similar ao PDF
        let textoCompartilhamento = '';
        
        // Linha 1: Descrição (ocasião) em negrito (WhatsApp usa *texto* para negrito)
        if (descricao) {
            textoCompartilhamento += `*${descricao}*\n`;
        }
        
        // Linha 2: Título
        textoCompartilhamento += titulo + '\n\n';
        
        // Linha 3: Peso total
        textoCompartilhamento += `${this.t('resultado.peso_texto', 'Para este evento, você precisará de')} ${pesoTotal} ${this.t('resultado.peso_kg', 'kg de carne.')}\n\n`;
        
        // Linha 4: Informações do evento (se houver pessoas)
        if (totalPessoas > 0) {
            const pessoasTexto = [];
            if (homens > 0) {
                pessoasTexto.push(`${homens} ${homens === 1 ? this.t('javascript.homem', 'homem') : this.t('javascript.homens', 'homens')}`);
            }
            if (mulheres > 0) {
                pessoasTexto.push(`${mulheres} ${mulheres === 1 ? this.t('javascript.mulher', 'mulher') : this.t('javascript.mulheres', 'mulheres')}`);
            }
            if (criancas > 0) {
                pessoasTexto.push(`${criancas} ${criancas === 1 ? this.t('javascript.crianca', 'criança') : this.t('javascript.criancas', 'crianças')}`);
            }
            
            if (pessoasTexto.length > 0) {
                textoCompartilhamento += `${this.t('javascript.total', 'Total de')} ${totalPessoas} ${totalPessoas === 1 ? this.t('javascript.pessoa', 'pessoa') : this.t('javascript.pessoas', 'pessoas')}: ${pessoasTexto.join(', ')}\n\n`;
            }
        }
        
        // Linha 5: Cortes selecionados (se houver)
        if (cortes.length > 0) {
            textoCompartilhamento += `${this.t('javascript.cortes_selecionados_label', 'Cortes selecionados:')}\n`;
            cortes.forEach(corte => {
                textoCompartilhamento += `• ${corte.nome}: ${corte.peso}kg\n`;
            });
            textoCompartilhamento += '\n';
        }
        
        // Linha final: URL (WhatsApp converte automaticamente em link)
        const urlAtual = window.location.href;
        textoCompartilhamento += urlAtual;

        // Criar versão resumida para redes sociais (sem quebras de linha)
        const textoResumido = `${descricao ? descricao + ' - ' : ''}${titulo}. ${this.t('resultado.peso_texto', 'Para este evento, você precisará de')} ${pesoTotal} ${this.t('resultado.peso_kg', 'kg de carne.')} ${urlAtual}`;

        // Armazenar dados em variável global para o modal acessar
        window.calculadoraShareData = {
            title: titulo,
            url: urlAtual,
            descricao: descricao,
            pesoTotal: pesoTotal,
            ocasiao: descricao,
            textoCompleto: textoCompartilhamento,
            textoResumido: textoResumido
        };

        // Disparar evento para abrir o modal
        // Usar setTimeout para garantir que o Alpine.js processe o evento
        setTimeout(() => {
            // Primeiro tentar abrir o modal diretamente via Alpine.js
            // Buscar o modal no documento original (não no overlay)
            const modalContainer = document.body.querySelector('.share-modal-container');
            if (modalContainer) {
                // Tentar acessar via Alpine.js
                if (window.Alpine && typeof window.Alpine.$data === 'function') {
                    try {
                        const alpineData = window.Alpine.$data(modalContainer);
                        if (alpineData) {
                            if (window.calculadoraShareData) {
                                Object.assign(alpineData.shareData, window.calculadoraShareData);
                            }
                            alpineData.open = true;
                            return;
                        }
                    } catch (e) {
                        console.warn('Erro ao acessar Alpine.js:', e);
                    }
                }
                
                // Fallback: tentar acessar diretamente via _x_dataStack
                if (modalContainer._x_dataStack && modalContainer._x_dataStack.length > 0) {
                    const alpineData = modalContainer._x_dataStack[0];
                    if (alpineData) {
                        if (window.calculadoraShareData) {
                            Object.assign(alpineData.shareData, window.calculadoraShareData);
                        }
                        alpineData.open = true;
                        return;
                    }
                }
            }
            
            // Se não conseguir acessar diretamente, disparar evento
            const event = new CustomEvent('open-share-modal', { bubbles: true, cancelable: true });
            window.dispatchEvent(event);
            document.dispatchEvent(event);
        }, 100);
    }

    fecharModal(overlay) {
        const modal = overlay.querySelector('.calculadora-modal-container');
        overlay.classList.remove('is-open');
        modal.classList.remove('is-open');
        modal.classList.add('is-closing');
        
        setTimeout(() => {
            overlay.remove();
        }, 300);
    }

    voltarParaHome() {
        const homeContainer = document.querySelector('.calculadora-de-churrasco-home, .calculadora-de-churrasco-cortes, .calculadora-de-churrasco-resultado');
        if (homeContainer && homeContainer.dataset.originalContent) {
            // Restaurar classes CSS originais
            homeContainer.className = 'calculadora-de-churrasco-home mb-8';
            // Restaurar data-lang se existir no conteúdo original
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = homeContainer.dataset.originalContent;
            const originalDataLang = tempDiv.querySelector('[data-lang]');
            if (originalDataLang) {
                homeContainer.setAttribute('data-lang', originalDataLang.getAttribute('data-lang'));
            }
            
            homeContainer.innerHTML = homeContainer.dataset.originalContent;
            // Restaurar altura e overflow originais (será aplicado pelo CSS)
            homeContainer.style.height = '';
            homeContainer.style.overflow = '';
            // Rebind dos eventos do formulário após restaurar o conteúdo
            this.bindEvents();
        }
    }
}

// Inicializar quando o DOM estiver carregado
document.addEventListener('DOMContentLoaded', () => {
    new CalculadoraChurrasco();
});
